/*
 * @Author: zhiwei.luo@zuolin.com
 * @Date: 2021-03-30 18:20:46
 * @Last Modified by: zhiwei.luo@zuolin.com
 * @Last Modified time: 2021-05-14 10:07:23
 *
 *  店铺审核
 */
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Loadable from 'react-loadable';
import { Loading } from 'components';

const Spin = () => <Loading loading />;

const ShopDetail = Loadable({
	loader: () => import('./routes/shop-detail'),
	loading: Spin,
});

const Main = Loadable({
	loader: () => import('./main.js'),
	loading: Spin,
});

export default ({ match }) => {
	return (
		<Switch>
			<Route exact path={`${match.url}/detail/:id/:type`} component={ShopDetail} />
			<Route path= {match.url} component={Main} />
		</Switch>
	);
};
